import { LEARNER_ROUTES } from '~/elc/features/learner/constants';
import { SearchParamOptions } from '../constants';

export const goToAdvancedSearch = (advancedSearchTerm: string) => {
  const queryParams = { [SearchParamOptions.QUERY]: advancedSearchTerm };
  const search = new URLSearchParams(queryParams).toString();
  const url = advancedSearchTerm ? `${LEARNER_ROUTES.search}?${search}` : LEARNER_ROUTES.search;
  window.location.assign(url);
};
